import React from 'react';
import { CreditCard, Clock, Gift } from 'lucide-react';

interface PaymentViewProps {
  cart: any[];
  customer: any;
  deliveryOption: string;
  onBack: () => void;
  onPaymentSelected: (status: string) => void;
  onSampleSelected: () => void;
}

function PaymentView({ cart, customer, deliveryOption, onBack, onPaymentSelected, onSampleSelected }: PaymentViewProps) {
  const totalItems = cart.reduce((sum, item) => sum + item.quantity, 0);
  const totalPrice = cart.reduce((sum, item) => sum + (item.price * item.quantity), 0);

  return (
    <div className="payment-view">
      <div className="payment-header">
        <button className="btn-secondary" onClick={onBack}>
          ← Atrás
        </button>
        <h1>Estado de Pago</h1>
        <div className="cart-summary-mini">
          <span>{totalItems} artículos</span>
          <span>${totalPrice.toFixed(2)}</span>
        </div>
      </div>

      <div className="payment-content">
        <div className="order-summary">
          <h3>Resumen del pedido:</h3>
          <div className="order-details">
            <p><strong>Cliente:</strong> {customer.name}</p>
            <p><strong>Entrega:</strong> {deliveryOption}</p>
          </div>
        </div>

        <div className="payment-options">
          <h3>Selecciona el estado de pago:</h3>
          
          <div className="payment-option" onClick={() => onPaymentSelected('Pagado')}>
            <div className="payment-option-icon">
              <CreditCard size={32} />
            </div>
            <div className="payment-option-content">
              <h4>Pagado</h4>
              <p>El cliente ya realizó el pago</p>
              <span className="payment-status">Estado: Pagado</span>
            </div>
            <div className="payment-option-select">→</div>
          </div>

          <div className="payment-option" onClick={() => onPaymentSelected('Por pagar')}>
            <div className="payment-option-icon">
              <Clock size={32} />
            </div>
            <div className="payment-option-content">
              <h4>Por pagar</h4>
              <p>Pendiente de pago</p>
              <span className="payment-status">Estado: Por pagar</span>
            </div>
            <div className="payment-option-select">→</div>
          </div>

          <div className="payment-option payment-option--sample" onClick={onSampleSelected}>
            <div className="payment-option-icon payment-option-icon--sample">
              <Gift size={32} />
            </div>
            <div className="payment-option-content">
              <h4>Muestra gratis</h4>
              <p>Sin costo para el cliente; se registra el costo de los productos</p>
              <span className="payment-status">Estado: Muestra</span>
            </div>
            <div className="payment-option-select">→</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentView; 